import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button, Grow } from '@mui/material';
import bgBtn from '../../assets/images/btn.png';
import { useSelector } from 'react-redux';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { calculateRankChange, findBestRankData } from '../../utils/rankUtils';
import { useStyles } from './styles';
import mowpodCharts from '../../assets/images/mowpod-charts.png';
import mowpodChartsLight from '../../assets/images/mowpod-charts-light.png';

export const ShareAchievementModal = ({ open, onClose, onShare }) => {
  const classes = useStyles({ bgBtn });

  const {
    currentPodcast,
    selectedCountry,
    topPodcasts: { data },
    genres,
  } = useSelector((state) => state.podcasts);
  const { isLight } = useSelector((state) => state.theme);

  const podcastData = findBestRankData(data, selectedCountry);
  const rankChange = podcastData ? calculateRankChange(podcastData) : { change: 0, direction: 'none' };

  const formatDate = () => {
    const now = new Date();
    return now.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const handleShareClick = () => {
    onShare();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Grow}
      TransitionProps={{
        timeout: {
          enter: 400,
          exit: 150,
        },
        easing: {
          enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
          exit: 'cubic-bezier(0.4, 0, 0.6, 1)',
        },
      }}
      PaperProps={{
        className: classes.dialogPaper,
        style: {
          backgroundColor: isLight ? '#ffffff' : '#1a1a1a',
        },
      }}
    >
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.header}>
          <img
            src={isLight ? mowpodChartsLight : mowpodCharts}
            alt="Mowpod Charts"
            className={classes.logo}
          />
        </Box>

        <Typography className={classes.rankDescription}>
          <span className={classes.rankNumber}>{`#${podcastData?.rank}` || '—'}</span> In {podcastData?.genre}
          <br />
          podcasts in {selectedCountry}
        </Typography>

        <Typography className={classes.date}>{formatDate()}</Typography>

        <Box className={classes.podcastInfo}>
          <img
            src={currentPodcast.artworkUrl600}
            alt={currentPodcast.collectionName}
            className={classes.podcastImage}
          />
          <Typography className={classes.podcastTitle}>{currentPodcast.collectionName}</Typography>
          <Typography className={classes.podcastArtist}>{currentPodcast.artistName}</Typography>
        </Box>

        <Box className={classes.genreInfo}>
          <Typography className={classes.genreCategory}>
            {genres?.map((genre, index) => (
              <span key={index}>
                {genre.name}
                {index < genres.length - 1 && (
                  <span style={{ color: 'var(--text-color)', fontStyle: 'italic' }}> | </span>
                )}
              </span>
            )) || podcastData?.genre}
          </Typography>
        </Box>

        <Button className={classes.shareButton} onClick={handleShareClick}>
          Share This
        </Button>
      </DialogContent>
    </Dialog>
  );
};
